import browser from 'helpers/browser';
import { frameToMs } from 'helpers/easings';
import { supportObserver } from 'helpers/observer';
import Component from 'navigation/component/Component';
class RevealList extends Component {
    incDelay;
    stagger;
    children = [];
    observer;
    constructor(el, options) {
        super(el, options);
        this.prepareChildren();
        setTimeout(() => {
            this.observe();
        }, frameToMs(7.5));
    }
    prepareChildren() {
        this.incDelay = 0;
        this.stagger = (+this.el.getAttribute('data-delay')) || 0.06;
        this.children = this.getChildren();
        this.observer = supportObserver && (new IntersectionObserver(this.onObserverUpdate, {
            rootMargin: '1000% 0px -5% 0px',
            threshold: 0
        }));
        this.observe();
    }
    reset() {
        if (this.children && this.observer) {
            this.children.forEach(child => {
                this.observer.unobserve(child);
            });
        }
        this.children = this.getChildren();
        this.observe();
    }
    getChildren() {
        return Array.from(this.el.children);
    }
    observe = () => {
        if (this.observer)
            this.children?.forEach(child => this.observer.observe(child));
        else
            this.onObserverUpdate(this.children?.map(child => ({ target: child, isIntersecting: true })));
    };
    hide() {
        if (this.observer)
            this.observer.disconnect();
    }
    onObserverUpdate = (entries) => {
        let previousTop = -1;
        entries?.forEach(({ target, isIntersecting }, index) => {
            if (isIntersecting) {
                const top = target.topLine;
                if (previousTop !== top)
                    this.incDelay = 0;
                const delay = this.stagger * Math.min(this.incDelay, 10);
                target.style.setProperty('--stagger-delay', delay + 's');
                this.incDelay++;
                previousTop = top;
            }
            browser.waitRepaint(() => {
                target.classList.toggle('reveal-show', isIntersecting);
            });
        });
    };
    resize() {
        super.resize();
        this.children.forEach((child, index) => {
            child.topLine = child.offsetTop;
        });
    }
    flush() {
        if (this.observer)
            this.observer.disconnect();
        this.children = null;
        this.observer = null;
        super.flush();
    }
}
export default RevealList;
